export enum ExportDocumentTypeEnum {
  pdf = 'pdf',
  excel = 'excel',
  none = 'none',
}